/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
// JQX Widget
import { jqxGridComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxgrid';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcGridComponent),
    multi: true
};

/**
 * Grid
 */

export class NgcGridComponent extends ControlComponent {
     altrows: any;
     altstart: any;
     altstep: any;
     autoshowloadelement: any;
     autoshowfiltericon: any;
     autoshowcolumnsmenubutton: any;
     clipboard: any;
     closeablegroups: any;
     columnsmenuwidth: any;
     columnmenuopening: any;
     columnmenuclosing: any;
     cellhover: any;
     enablekeyboarddelete: any;
     enableellipsis: any;
     enablemousewheel: any;
     enableanimations: any;
     enabletooltips: any;
     enablehover: any;
     enablebrowserselection: any;
     everpresentrowposition: any;
     everpresentrowheight: any;
     everpresentrowactions: any;
     everpresentrowactionsmode: any;
     filterrowheight: any;
     filtermode: any;
     groupsrenderer: any;
     groupcolumnrenderer: any;
     groupsexpandedbydefault: any;
     handlekeyboardnavigation: any;
     pagerrenderer: any;
     rtl: any;
     showdefaultloadelement: any;
     showfiltercolumnbackground: any;
     showfiltermenuitems: any;
     showpinnedcolumnbackground: any;
     showsortcolumnbackground: any;
     showsortmenuitems: any;
     showgroupmenuitems: any;
     showrowdetailscolumn: any;
     showheader: any;
     showgroupsheader: any;
     showaggregates: any;
     showgroupaggregates: any;
     showeverpresentrow: any;
     showfilterrow: any;
     showemptyrow: any;
     showstatusbar: any;
     statusbarheight: any;
     showtoolbar: any;
     selectionmode: any;
     theme: any;
     toolbarheight: any;
     autoheight: any;
     autorowheight: any;
     columnsheight: any;
     deferreddatafields: any;
     groupsheaderheight: any;
     groupindentwidth: any;
     pagerheight: any;
     rowsheight: any;
     scrollbarsize: any;
     scrollmode: any;
     scrollfeedback: any;
     autosavestate: any;
     autoloadstate: any;
     columns: any;
     columngroups: any;
     columnsmenu: any;
     columnsresize: any;
     columnsautoresize: any;
     columnsreorder: any;
     editable: any;
     editmode: any;
     filter: any;
     filterable: any;
     groupable: any;
     groups: any;
     horizontalscrollbarstep: any;
     horizontalscrollbarlargestep: any;
     initrowdetails: any;
     keyboardnavigation: any;
     localization: any;
     pagesize: any;
     pagesizeoptions: any;
     pagermode: any;
     pagerbuttonscount: any;
     pageable: any;
     rowdetails: any;
     rowdetailstemplate: any;
     ready: any;
     rendered: any;
     renderstatusbar: any;
     rendertoolbar: any;
     rendergridrows: any;
     sortable: any;
     selectedrowindex: any;
     selectedrowindexes: any;
     source: any;
     sorttogglestates: any;
     updatedelay: any;
     virtualmode: any;
     verticalscrollbarstep: any;
     verticalscrollbarlargestep: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-grid',
    template: `<jqxGrid *ngIf="visible"
                [altrows] = "altrows"
                [altstart] = "altstart"
                [altstep] = "altstep"
                [autoshowloadelement] = "autoshowloadelement"
                [autoshowfiltericon] = "autoshowfiltericon"
                [autoshowcolumnsmenubutton] = "autoshowcolumnsmenubutton"
                [clipboard] = "clipboard"
                [closeablegroups] = "closeablegroups"
                [columnsmenuwidth] = "columnsmenuwidth"
                [columnmenuopening] = "columnmenuopening"
                [columnmenuclosing] = "columnmenuclosing"
                [cellhover] = "cellhover"
                [enablekeyboarddelete] = "enablekeyboarddelete"
                [enableellipsis] = "enableellipsis"
                [enablemousewheel] = "enablemousewheel"
                [enableanimations] = "enableanimations"
                [enabletooltips] = "enabletooltips"
                [enablehover] = "enablehover"
                [enablebrowserselection] = "enablebrowserselection"
                [everpresentrowposition] = "everpresentrowposition"
                [everpresentrowheight] = "everpresentrowheight"
                [everpresentrowactions] = "everpresentrowactions"
                [everpresentrowactionsmode] = "everpresentrowactionsmode"
                [filterrowheight] = "filterrowheight"
                [filtermode] = "filtermode"
                [groupsrenderer] = "groupsrenderer"
                [groupcolumnrenderer] = "groupcolumnrenderer"
                [groupsexpandedbydefault] = "groupsexpandedbydefault"
                [handlekeyboardnavigation] = "handlekeyboardnavigation"
                [pagerrenderer] = "pagerrenderer"
                [rtl] = "rtl"
                [showdefaultloadelement] = "showdefaultloadelement"
                [showfiltercolumnbackground] = "showfiltercolumnbackground"
                [showfiltermenuitems] = "showfiltermenuitems"
                [showpinnedcolumnbackground] = "showpinnedcolumnbackground"
                [showsortcolumnbackground] = "showsortcolumnbackground"
                [showsortmenuitems] = "showsortmenuitems"
                [showgroupmenuitems] = "showgroupmenuitems"
                [showrowdetailscolumn] = "showrowdetailscolumn"
                [showheader] = "showheader"
                [showgroupsheader] = "showgroupsheader"
                [showaggregates] = "showaggregates"
                [showgroupaggregates] = "showgroupaggregates"
                [showeverpresentrow] = "showeverpresentrow"
                [showfilterrow] = "showfilterrow"
                [showemptyrow] = "showemptyrow"
                [showstatusbar] = "showstatusbar"
                [statusbarheight] = "statusbarheight"
                [showtoolbar] = "showtoolbar"
                [selectionmode] = "selectionmode"
                [theme] = "theme"
                [toolbarheight] = "toolbarheight"
                [autoheight] = "autoheight"
                [autorowheight] = "autorowheight"
                [columnsheight] = "columnsheight"
                [deferreddatafields] = "deferreddatafields"
                [groupsheaderheight] = "groupsheaderheight"
                [groupindentwidth] = "groupindentwidth"
                [pagerheight] = "pagerheight"
                [rowsheight] = "rowsheight"
                [scrollbarsize] = "scrollbarsize"
                [scrollmode] = "scrollmode"
                [scrollfeedback] = "scrollfeedback"
                [autosavestate] = "autosavestate"
                [autoloadstate] = "autoloadstate"
                [columns] = "columns"
                [columngroups] = "columngroups"
                [columnsmenu] = "columnsmenu"
                [columnsresize] = "columnsresize"
                [columnsautoresize] = "columnsautoresize"
                [columnsreorder] = "columnsreorder"
                [disabled] = "disabled"
                [editable] = "editable"
                [editmode] = "editmode"
                [filter] = "filter"
                [filterable] = "filterable"
                [groupable] = "groupable"
                [groups] = "groups"
                [horizontalscrollbarstep] = "horizontalscrollbarstep"
                [horizontalscrollbarlargestep] = "horizontalscrollbarlargestep"
                [initrowdetails] = "initrowdetails"
                [keyboardnavigation] = "keyboardnavigation"
                [localization] = "localization"
                [pagesize] = "pagesize"
                [pagesizeoptions] = "pagesizeoptions"
                [pagermode] = "pagermode"
                [pagerbuttonscount] = "pagerbuttonscount"
                [pageable] = "pageable"
                [rowdetails] = "rowdetails"
                [rowdetailstemplate] = "rowdetailstemplate"
                [ready] = "ready"
                [rendered] = "rendered"
                [renderstatusbar] = "renderstatusbar"
                [rendertoolbar] = "rendertoolbar"
                [rendergridrows] = "rendergridrows"
                [sortable] = "sortable"
                [selectedrowindex] = "selectedrowindex"
                [selectedrowindexes] = "selectedrowindexes"
                [source] = "source"
                [sorttogglestates] = "sorttogglestates"
                [updatedelay] = "updatedelay"
                [virtualmode] = "virtualmode"
                [verticalscrollbarstep] = "verticalscrollbarstep"
                [verticalscrollbarlargestep] = "verticalscrollbarlargestep"
                [width] = "width"
                [height] = "height">
                </jqxGrid>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'altrows': [{ type: Input, args: ['altrows', ] },],
'altstart': [{ type: Input, args: ['altstart', ] },],
'altstep': [{ type: Input, args: ['altstep', ] },],
'autoshowloadelement': [{ type: Input, args: ['autoshowloadelement', ] },],
'autoshowfiltericon': [{ type: Input, args: ['autoshowfiltericon', ] },],
'autoshowcolumnsmenubutton': [{ type: Input, args: ['autoshowcolumnsmenubutton', ] },],
'clipboard': [{ type: Input, args: ['clipboard', ] },],
'closeablegroups': [{ type: Input, args: ['closeablegroups', ] },],
'columnsmenuwidth': [{ type: Input, args: ['columnsmenuwidth', ] },],
'columnmenuopening': [{ type: Input, args: ['columnmenuopening', ] },],
'columnmenuclosing': [{ type: Input, args: ['columnmenuclosing', ] },],
'cellhover': [{ type: Input, args: ['cellhover', ] },],
'enablekeyboarddelete': [{ type: Input, args: ['enablekeyboarddelete', ] },],
'enableellipsis': [{ type: Input, args: ['enableellipsis', ] },],
'enablemousewheel': [{ type: Input, args: ['enablemousewheel', ] },],
'enableanimations': [{ type: Input, args: ['enableanimations', ] },],
'enabletooltips': [{ type: Input, args: ['enabletooltips', ] },],
'enablehover': [{ type: Input, args: ['enablehover', ] },],
'enablebrowserselection': [{ type: Input, args: ['enablebrowserselection', ] },],
'everpresentrowposition': [{ type: Input, args: ['everpresentrowposition', ] },],
'everpresentrowheight': [{ type: Input, args: ['everpresentrowheight', ] },],
'everpresentrowactions': [{ type: Input, args: ['everpresentrowactions', ] },],
'everpresentrowactionsmode': [{ type: Input, args: ['everpresentrowactionsmode', ] },],
'filterrowheight': [{ type: Input, args: ['filterrowheight', ] },],
'filtermode': [{ type: Input, args: ['filtermode', ] },],
'groupsrenderer': [{ type: Input, args: ['groupsrenderer', ] },],
'groupcolumnrenderer': [{ type: Input, args: ['groupcolumnrenderer', ] },],
'groupsexpandedbydefault': [{ type: Input, args: ['groupsexpandedbydefault', ] },],
'handlekeyboardnavigation': [{ type: Input, args: ['handlekeyboardnavigation', ] },],
'pagerrenderer': [{ type: Input, args: ['pagerrenderer', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'showdefaultloadelement': [{ type: Input, args: ['showdefaultloadelement', ] },],
'showfiltercolumnbackground': [{ type: Input, args: ['showfiltercolumnbackground', ] },],
'showfiltermenuitems': [{ type: Input, args: ['showfiltermenuitems', ] },],
'showpinnedcolumnbackground': [{ type: Input, args: ['showpinnedcolumnbackground', ] },],
'showsortcolumnbackground': [{ type: Input, args: ['showsortcolumnbackground', ] },],
'showsortmenuitems': [{ type: Input, args: ['showsortmenuitems', ] },],
'showgroupmenuitems': [{ type: Input, args: ['showgroupmenuitems', ] },],
'showrowdetailscolumn': [{ type: Input, args: ['showrowdetailscolumn', ] },],
'showheader': [{ type: Input, args: ['showheader', ] },],
'showgroupsheader': [{ type: Input, args: ['showgroupsheader', ] },],
'showaggregates': [{ type: Input, args: ['showaggregates', ] },],
'showgroupaggregates': [{ type: Input, args: ['showgroupaggregates', ] },],
'showeverpresentrow': [{ type: Input, args: ['showeverpresentrow', ] },],
'showfilterrow': [{ type: Input, args: ['showfilterrow', ] },],
'showemptyrow': [{ type: Input, args: ['showemptyrow', ] },],
'showstatusbar': [{ type: Input, args: ['showstatusbar', ] },],
'statusbarheight': [{ type: Input, args: ['statusbarheight', ] },],
'showtoolbar': [{ type: Input, args: ['showtoolbar', ] },],
'selectionmode': [{ type: Input, args: ['selectionmode', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'toolbarheight': [{ type: Input, args: ['toolbarheight', ] },],
'autoheight': [{ type: Input, args: ['autoheight', ] },],
'autorowheight': [{ type: Input, args: ['autorowheight', ] },],
'columnsheight': [{ type: Input, args: ['columnsheight', ] },],
'deferreddatafields': [{ type: Input, args: ['deferreddatafields', ] },],
'groupsheaderheight': [{ type: Input, args: ['groupsheaderheight', ] },],
'groupindentwidth': [{ type: Input, args: ['groupindentwidth', ] },],
'pagerheight': [{ type: Input, args: ['pagerheight', ] },],
'rowsheight': [{ type: Input, args: ['rowsheight', ] },],
'scrollbarsize': [{ type: Input, args: ['scrollbarsize', ] },],
'scrollmode': [{ type: Input, args: ['scrollmode', ] },],
'scrollfeedback': [{ type: Input, args: ['scrollfeedback', ] },],
'autosavestate': [{ type: Input, args: ['autosavestate', ] },],
'autoloadstate': [{ type: Input, args: ['autoloadstate', ] },],
'columns': [{ type: Input, args: ['columns', ] },],
'columngroups': [{ type: Input, args: ['columngroups', ] },],
'columnsmenu': [{ type: Input, args: ['columnsmenu', ] },],
'columnsresize': [{ type: Input, args: ['columnsresize', ] },],
'columnsautoresize': [{ type: Input, args: ['columnsautoresize', ] },],
'columnsreorder': [{ type: Input, args: ['columnsreorder', ] },],
'editable': [{ type: Input, args: ['editable', ] },],
'editmode': [{ type: Input, args: ['editmode', ] },],
'filter': [{ type: Input, args: ['filter', ] },],
'filterable': [{ type: Input, args: ['filterable', ] },],
'groupable': [{ type: Input, args: ['groupable', ] },],
'groups': [{ type: Input, args: ['groups', ] },],
'horizontalscrollbarstep': [{ type: Input, args: ['horizontalscrollbarstep', ] },],
'horizontalscrollbarlargestep': [{ type: Input, args: ['horizontalscrollbarlargestep', ] },],
'initrowdetails': [{ type: Input, args: ['initrowdetails', ] },],
'keyboardnavigation': [{ type: Input, args: ['keyboardnavigation', ] },],
'localization': [{ type: Input, args: ['localization', ] },],
'pagesize': [{ type: Input, args: ['pagesize', ] },],
'pagesizeoptions': [{ type: Input, args: ['pagesizeoptions', ] },],
'pagermode': [{ type: Input, args: ['pagermode', ] },],
'pagerbuttonscount': [{ type: Input, args: ['pagerbuttonscount', ] },],
'pageable': [{ type: Input, args: ['pageable', ] },],
'rowdetails': [{ type: Input, args: ['rowdetails', ] },],
'rowdetailstemplate': [{ type: Input, args: ['rowdetailstemplate', ] },],
'ready': [{ type: Input, args: ['ready', ] },],
'rendered': [{ type: Input, args: ['rendered', ] },],
'renderstatusbar': [{ type: Input, args: ['renderstatusbar', ] },],
'rendertoolbar': [{ type: Input, args: ['rendertoolbar', ] },],
'rendergridrows': [{ type: Input, args: ['rendergridrows', ] },],
'sortable': [{ type: Input, args: ['sortable', ] },],
'selectedrowindex': [{ type: Input, args: ['selectedrowindex', ] },],
'selectedrowindexes': [{ type: Input, args: ['selectedrowindexes', ] },],
'source': [{ type: Input, args: ['source', ] },],
'sorttogglestates': [{ type: Input, args: ['sorttogglestates', ] },],
'updatedelay': [{ type: Input, args: ['updatedelay', ] },],
'virtualmode': [{ type: Input, args: ['virtualmode', ] },],
'verticalscrollbarstep': [{ type: Input, args: ['verticalscrollbarstep', ] },],
'verticalscrollbarlargestep': [{ type: Input, args: ['verticalscrollbarlargestep', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
};
}

/**
 * Grid Module
 */

export class NgcGridModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [NgcGridComponent],
    declarations: [NgcGridComponent, jqxGridComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
